<template>
  <generic-modal :title="$t('movement type')" ref="generic_modal">
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("name") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.name" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("behavior") }}</label>
          <div class="buttons">
            <div
              class="button"
              @click="meta.behavior = 'credit'"
              v-bind:class="{ 'is-active': meta.behavior == 'credit' }"
            >
              <span class="icon has-text-success">
                <i class="fa fa-angle-right"></i>
              </span>
              <span>{{ $t("credit") }}</span>
            </div>
            <div
              class="button"
              @click="meta.behavior = 'charge'"
              v-bind:class="{ 'is-active': meta.behavior == 'charge' }"
            >
              <span class="icon has-text-danger">
                <i class="fa fa-angle-left"></i>
              </span>
              <span>{{ $t("charge") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-three-fifths">
        <div class="field">
          <generic-dropdown
            :title="$t('movement to apply on reverse')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/account/movement_type/catalog"
            name_field="name"
            value_field="movement_type_id"
            @selected="type_changed"
            ref="type_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("default amount") }}</label>
          <div class="control has-icons-left has-icons-right">
            <input
              class="input"
              type="text"
              v-model="meta.settings.default_amount"
              placeholder="{{ $t('default amount') }}"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-money"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p>{{ error }}</p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "MovementTypeModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {
        settings: {},
      },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.behavior;
    },
  },
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/account/movement_type", { uuid: uuid })
        .then((product) => {
          v.meta = product;
          if (v.meta.settings.reverse_movement_type_id)
            v.$refs.type_dropdown.set_value(
              v.meta.settings.reverse_movement_type_id
            );
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/account/movement_type", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/account/movement_type", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        behavior: "",
        settings: {},
      };
      v.$refs.type_dropdown.clear();
      v.error = "";
      // v.uuid = "";
    },
    type_changed(type) {
      let v = this;
      if (type)
        v.meta.settings.reverse_movement_type_id = type.movement_type_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
